import React, { useEffect } from "react";
import { useState } from 'react'
import { CheckIcon } from "@heroicons/react/24/outline";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import TextInput from "../../components/TextInput";
import FileInput from "../../components/FileInput";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import PatientModuleHeader from "../../components/patients/layout/PatientModuleHeader";
import PatientModuleLayout from "../../components/patients/layout/PatientModuleLayout";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const radio = [
    { id: "male", default: true, label: "Masculino", value: 1 },
    { id: "female", default: false, label: "Femenino", value: 2 }
]

const roles = [
    { id: "resident", default: true, label: "Dr. Residente", value: 1 },
    { id: "senior", default: false, label: "Dr. Senior", value: 3 },
    { id: "secretary", default: false, label: "Secretaría", value: 2 },
    { id: "admin", default: false, label: "Administrador", value: 4 },
    { id: "bachelor", default: false, label: "Licenciado", value: 5 },
]

export default function ProfilePage() {

    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [sidebarOpenDesktop, setSidebarOpenDesktop] = useState(true)
    const isDesktop = useMediaQuery("(min-width: 1024px)")
    const [loading, setLoading] = useState(true)
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const [user, setUser] = useState({
        sex: 1,
        role: 1,
    });
    const [error, setError] = useState({});
    const [idUser, setIdUser] = useState(JSON.parse(localStorage.getItem('BDOuserData'))?.id)

    const handleChange = (field, value) => setUser((prev) => ({ ...prev, [field]: value }));
    const handleSidebarToggle = () => {
        if (isDesktop) {
            setSidebarOpenDesktop(!sidebarOpenDesktop);
            return;
        }
        setSidebarOpen(true);
    };

    const handleSubmit = (event) => {
        event.preventDefault()
        setSuccess(false);
        let error = false
        if (user.role === '4' || user.role === '2') {
            delete user.digitalSignature
            delete user.specialty
            delete user.registrationNumber
        }
        if (user.role === '1' || user.role === '3' || user.role === 1 || user.role === 3) {
            let formData = new FormData();
            for (var key in user) {
                if (user[key] && (key !== 'digitalSignature' || typeof user[key] === 'object')) {
                    formData.append(key, user[key]);
                }
            }
            api.users.update(idUser, formData).then((response) => { setSuccess(true) }).catch((error) => setError(error.message))
        } else {
            api.users.update(idUser, user).then((response) => { setSuccess(true) }).catch((error) => setError(error.message))
        }
    };

    useEffect(() => {
        if (idUser) {
            api.users.getMe().then((response) => {
                setUser({ ...response, role: response.role.toString() })
            })
        }
    }, [])

    useEffect(() => {
        if (isDesktop) {
            setSidebarOpen(false);
        }
    }, [isDesktop])

    useEffect(() => {
        if (user.role === '4' || user.role === '2') {
            delete user.digitalSignature
            delete user.specialty
            delete user.registrationNumber
        }
    }, [user.role])

    const pages = [
        { name: 'Perfil', href: '#', current: false },
        { name: 'Editar', href: '#', current: true },
    ]

    return (
        <PatientModuleLayout
            currentScreen="Perfil"
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarOpenDesktop={sidebarOpenDesktop}
            header={
                <PatientModuleHeader
                    pages={pages}
                    onToggleSidebar={handleSidebarToggle}
                    mobileBackTo="/profile"
                    mobileBackLabel="Perfil"
                    mobileTitle="Editar perfil"
                    actions={
                        <button
                            type="submit"
                            form="profile-form"
                            className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-3 py-2.5 text-sm font-semibold text-white shadow-sm"
                        >
                            <CheckIcon className="h-5 w-5" />
                            <span className="hidden sm:inline">Guardar cambios</span>
                            <span className="sm:hidden">Guardar</span>
                        </button>
                    }
                />
            }
        >
            <div className="px-4 py-6 sm:px-6 lg:px-8">
                <form id="profile-form" onSubmit={(event) => handleSubmit(event)}>
                    <div className="mx-auto w-full max-w-5xl rounded-lg bg-white p-4 shadow-sm dark:bg-gray-900 sm:p-6 lg:p-8">
                        <p className="text-[#111827] dark:text-white font-medium text-lg">Información del usuario</p>
                        <div className="border border-[#E5E7EB] my-4 w-full" />
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-8">
                            <TextInput showErrorMessage={true} containerClassName='w-full' errorMessage={error?.firstName} value={user?.firstName} handleChange={handleChange} name="firstName" label="Nombres" />
                            <TextInput showErrorMessage={true} containerClassName='w-full' errorMessage={error?.lastName} value={user?.lastName} handleChange={handleChange} name="lastName" label="Apellidos" />
                            <TextInput showErrorMessage={true} containerClassName='w-full' errorMessage={error?.email} value={user?.email} handleChange={handleChange} name="email" label="Correo Electrónico" />
                            <TextInput showErrorMessage={true} containerClassName='w-full' errorMessage={error?.govId} value={user?.govId} handleChange={handleChange} name="govId" label="Cédula de identidad" />
                            <TextInput showErrorMessage={true} containerClassName='w-full' errorMessage={error.cellphone} handleChange={handleChange} value={user.cellphone} name="cellphone" label="Celular" />
                            {(user?.role === '1' || user?.role === '3') && <TextInput showErrorMessage={true} containerClassName='w-full' errorMessage={error.registrationNumber} handleChange={handleChange} value={user.registrationNumber} name="registrationNumber" label="Reg. Prof. Nro" />}
                            {(user?.role === '1' || user?.role === '3') && <FileInput label='Firma' buttonText='Adjuntar Firma' handleChange={handleChange} name='digitalSignature' value={user?.digitalSignature} />}
                            {((user?.role === '1' || user?.role === '3') && user?.digitalSignature) && <img alt='signature' src={typeof user.digitalSignature === 'string' ? process.env.REACT_APP_API_BASE_URL + user?.digitalSignature : URL.createObjectURL(user?.digitalSignature)} height={128} width={128} />}
                        </div>
                        {success &&
                            <div className="bg-white border border-gray-300 mt-4 w-fit py-2 px-4 rounded-xl dark:bg-gray-900 dark:text-white">
                                Sus cambios han sido guardados exitosamente.
                            </div>
                        }
                    </div>
                </form>
            </div>
        </PatientModuleLayout>
    );
}
